import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_INVOICE_CLIENT_RESET   = 'DELETE_INVOICE_CLIENT_RESET';
export const DELETE_INVOICE_CLIENT_LOADING = 'DELETE_INVOICE_CLIENT_LOADING';
export const DELETE_INVOICE_CLIENT_SUCCESS = 'DELETE_INVOICE_CLIENT_SUCCESS';
export const DELETE_INVOICE_CLIENT_REJECT  = 'DELETE_INVOICE_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteInvoiceClientReset   = () => ({ type: DELETE_INVOICE_CLIENT_RESET });
export const deleteInvoiceClientLoading = () => ({ type: DELETE_INVOICE_CLIENT_LOADING });
export const deleteInvoiceClientSuccess = (payload) => ({ type: DELETE_INVOICE_CLIENT_SUCCESS, payload });
export const deleteInvoiceClientReject  = (payload) => ({ type: DELETE_INVOICE_CLIENT_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const deleteInvoiceClientRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        params,
    }, getState);
    return request(`/Invoices/web/DeleteInvoices`, options);
};
